// extracted by mini-css-extract-plugin
export var progressBar = "_nc-0";
export var progressBarInner = "_nc-1";